import { render, staticRenderFns } from "./SalesOrderTracker.vue?vue&type=template&id=22bafbdc&"
import script from "./SalesOrderTracker.vue?vue&type=script&lang=js&"
export * from "./SalesOrderTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports